import i18next from 'i18next';
import { toast } from 'sonner';

import { getIntegrationErrorMessage } from '@/lib/integration-error-message.js';

const errMsg = (e, fb) => getIntegrationErrorMessage(e) || fb;

export class TenantComplianceIntegration {
    constructor(service) { this.service = service; }

    async frameworks() {
        try { const r = await this.service.frameworks(); return { success: true, data: r.data }; }
        catch (e) { const m = errMsg(e, i18next.t('integrationToasts:couldNotLoadFrameworks', { defaultValue: 'Could not load frameworks' })); toast.error(m); return { success: false, error: m }; }
    }
    async get() {
        try { const r = await this.service.get(); return { success: true, data: r.data }; }
        catch (e) { const m = errMsg(e, i18next.t('integrationToasts:couldNotLoadConfiguration', { defaultValue: 'Could not load configuration' })); toast.error(m); return { success: false, error: m }; }
    }
    async toggle(code, enabled, customizations) {
        try {
            const r = await this.service.toggle(code, enabled, customizations);
            toast.success(i18next.t('integrationToasts:complianceUpdated', { defaultValue: 'Compliance updated' }));
            return { success: true, data: r.data };
        } catch (e) { const m = errMsg(e, i18next.t('integrationToasts:couldNotUpdate', { defaultValue: 'Could not update' })); toast.error(m); return { success: false, error: m }; }
    }

    async listCatalogs() {
        try {
            const r = await this.service.listCatalogs();
            return { success: true, data: r.data || [], meta: r.meta };
        } catch (e) {
            const m = errMsg(
                e,
                i18next.t('admin:complianceFrameworks.messages.loadError', {
                    defaultValue: 'Could not load catalogs',
                }),
            );
            toast.error(m);
            return { success: false, error: m, data: [] };
        }
    }

    async getCatalogScopeOptions() {
        try {
            const r = await this.service.getCatalogScopeOptions();
            return { success: true, data: r.data || [] };
        } catch (e) {
            return {
                success: false,
                data: [],
                error: errMsg(e, i18next.t('admin:complianceFrameworks.messages.loadError', {
                    defaultValue: 'Could not load scope options',
                })),
            };
        }
    }

    async getCatalogCategoryOptions() {
        try {
            const r = await this.service.getCatalogCategoryOptions();
            return { success: true, data: r.data || [] };
        } catch (e) {
            return {
                success: false,
                data: [],
                error: errMsg(e, i18next.t('admin:complianceFrameworks.messages.loadError', {
                    defaultValue: 'Could not load category options',
                })),
            };
        }
    }

    async getCatalogControls(tag, params = {}) {
        try {
            const r = await this.service.listCatalogControls(tag, params);
            return {
                success: true,
                data: r.data || [],
                pagination: r.pagination || {},
            };
        } catch (e) {
            const m = errMsg(
                e,
                i18next.t('admin:complianceFrameworks.messages.controlsLoadError', {
                    defaultValue: 'Could not load catalog controls',
                }),
            );
            toast.error(m);
            return { success: false, error: m, data: [], pagination: {} };
        }
    }

    async updateCatalog(tag, payload = {}) {
        try {
            const r = await this.service.updateCatalog(tag, payload);
            toast.success(
                i18next.t('admin:complianceFrameworks.messages.updateSuccess', {
                    defaultValue: 'Catalog updated successfully',
                }),
            );
            return { success: true, data: r.data };
        } catch (e) {
            const m = errMsg(
                e,
                i18next.t('admin:complianceFrameworks.messages.updateError', {
                    defaultValue: 'Could not update catalog',
                }),
            );
            toast.error(m);
            return { success: false, error: m };
        }
    }
}
